export enum PalantirSizeEnum {
  '2xl' = '2xl',
  '2xs' = '2xs',
  '3xl' = '3xl',
  '4xl' = '4xl',
  '5xl' = '5xl',
  '6xl' = '6xl',
  '7xl' = '7xl',
  '8xl' = '8xl',
  'base' = 'base',
  'lg' = 'lg',
  'xl' = 'xl',
  'xs' = 'xs',
}

export type PalantirSize = keyof typeof PalantirSizeEnum;
